import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { VideoAppointmentLaunchService } from '../../../api/gen';
import {
  AuthenticationService,
  AuthRedirectState,
} from '../../authentication/authentication.service';

@Component({
  selector: 'app-video-appointment-launch',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<p role="status">Video Appointment wird gestartet …</p>`,
  styles: `
    :host {
      align-items: center;
      display: flex;
      justify-content: center;
      min-height: 100vh;
      text-align: center;
    }
  `,
})
export class VideoAppointmentLaunchComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthenticationService);
  private readonly launchService = inject(VideoAppointmentLaunchService);

  async ngOnInit(): Promise<void> {
    const token = this.route.snapshot.paramMap.get('token');
    if (!token) {
      await this.showUnavailablePage();
      return;
    }

    const user = await firstValueFrom(this.authService.getUser());
    if (!user || user.expired) {
      await this.authService.login({
        state: {
          postLoginPath: `/integration/video-appointment/${token}`,
        } satisfies AuthRedirectState,
      });
      return;
    }

    try {
      const appointment = await firstValueFrom(
        this.launchService.videoAppointmentLaunchesTokenConsumePost(token),
      );
      await this.router.navigate(
        ['/video-appointment', appointment.inquiryIdentifier, appointment.id],
        { replaceUrl: true },
      );
    } catch {
      await this.showUnavailablePage();
    }
  }

  private async showUnavailablePage(): Promise<void> {
    await this.router.navigate(
      ['/integration/video-appointment/not-available'],
      { replaceUrl: true },
    );
  }
}
